import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import '../../components/main.css'

const IndexPage = () => (
  <Layout lang="en">
    <SEO title="Software Development Agency" />
    <div className="hero">We are software development company. We help companies at any stage of the product software development cycle: from R&D and building MVP from scratch, to scaling, UX analyzing and improving.</div>
    <div className="animation"></div>
  </Layout>
)

export default IndexPage
